module.exports = __webpack_public_path__ + "img/abc.c1434868.jpg";